// 初回無料キャンペーン関連のステータス
const initialState = () => ({
  selectProductId: 0,
  selectedDestination: null,
  designImageFile: null,
  cutlineImageFile: null,
  scCutlineImageFile: null,
  designImageURL: null,
  cutlineImageURL: null,
  scCutlineImageURL: null,
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    reset(state) {
      Object.assign(state, initialState())
    },
    set(state, { key, value }) {
      if (key in state) {
        state[key] = value;
      }
    },
  },
}
